var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserProfilIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon user-profile-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 0a5.828 5.828 0 015.822 5.833 5.832 5.832 0 01-2.368 4.697c3.69.853 5.863 3.233 6.517 7.14a2 2 0 01-1.821 2.325l-.15.005H1.999a1.997 1.997 0 01-1.972-2.33c.654-3.907 2.827-6.287 6.519-7.14a5.83 5.83 0 01-2.367-4.696C4.18 2.612 6.787 0 10.002 0zM10 11.67c-5.113 0-7.785 2.01-8.495 6.247a.5.5 0 00.41.576l.041.005.042.002h16.005a.5.5 0 00.492-.583c-.71-4.238-3.381-6.247-8.495-6.247zm.002-10.17a4.329 4.329 0 00-4.324 4.333c0 2.394 1.936 4.334 4.324 4.334s4.324-1.94 4.324-4.334A4.329 4.329 0 0010.002 1.5z"
  })));
}

export default SvgUserProfilIconSv;